import { render, staticRenderFns } from "./ReferenceArrayField.vue?vue&type=template&id=236cfbcd&scoped=true&"
import script from "./ReferenceArrayField.vue?vue&type=script&lang=js&"
export * from "./ReferenceArrayField.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceArrayField.vue?vue&type=style&index=0&id=236cfbcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236cfbcd",
  null
  
)

export default component.exports